import React, { useState } from "react";
import PropTypes from "prop-types";
import queryString from "query-string";

import FakeSelect from "./fakeselect";
import { periods, municipalities } from "./data";

const Uit = ({ title, description, url, buttonText }) => {
  const [when, setWhen] = useState("");
  const [where, setWhere] = useState("");

  return (
    <>
      <svg className="special-uit__powered-by">
        <use
          xmlnsXlink="http://www.w3.org/1999/xlink"
          xlinkHref="#powered-by-uit"
        />
      </svg>
      <h3 className="special-quote__title">{title}</h3>,
      <div
        className="special-quote__text text"
        dangerouslySetInnerHTML={{ __html: description }}
      />
      <div className="special-uit__container">
        <FakeSelect
          className="special-uit__select"
          title="Kies een periode"
          icon={["calendar", 18, 17]}
          valueKey="name"
          onChange={(event) => setWhen(event.target.value)}
        >
          {periods.map((period) => (
            <option value={period.key} data-name={period.value}>
              {period.value}
            </option>
          ))}
        </FakeSelect>
        <FakeSelect
          className="special-uit__select"
          title="Kies een gemeente"
          icon={["location", 16, 19]}
          valueKey="name"
          onChange={(event) => setWhere(event.target.value)}
        >
          {municipalities
            .map((municipality) => ({
              ...municipality,
              value: `${municipality.postal} ${municipality.name}`,
            }))
            .map((municipality) => (
              <option value={municipality.key} data-name={municipality.value}>
                {municipality.value}
              </option>
            ))}
        </FakeSelect>
      </div>
      <a
        href={`${url}?${queryString.stringify({ when, where })}`}
        target="_blank"
        rel="noreferrer noopener"
        className="btn is-default"
      >
        <span className="btn__text">{buttonText}</span>
        <svg className="btn__icon is-suffix" width="14px" height="14px">
          <use
            xmlnsXlink="http://www.w3.org/1999/xlink"
            xlinkHref="#arrow-right"
            width="14"
            height="14"
          />
        </svg>
      </a>
    </>
  );
};

Uit.propTypes = {
  title: PropTypes.string.isRequired,
  description: PropTypes.string.isRequired,
  url: PropTypes.string.isRequired,
  buttonText: PropTypes.string.isRequired,
};

export default Uit;
